import { Dispatch, SetStateAction } from "react";
import { Alert } from "@nexstar-network/shared-utils";
import { DateTime } from "luxon";
import { RESTAPIErrorType } from "../../../types/ErrorMessageType";
import { handleRESTErrors } from "../../../utils/helpers/RequestHelpers";

export const handleMarkSingleAsRead = (
  ev,
  alertID: number,
  numberOfUnread: number,
  setNumberOfUnread: Dispatch<SetStateAction<number>>,
  markAlertsAsRead: any,
  queryClient: any,
  refetch: any,
  preventDefault: boolean,
  enqueueSnackbar: any,
) => {
  setNumberOfUnread(() => numberOfUnread - 1);
  markAlertsAsRead.mutate(alertID, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["getNotifications"], {
        refetchType: "all",
      });
      refetch();
    },
    onError: (saveError: RESTAPIErrorType) => {
      handleRESTErrors(saveError, enqueueSnackbar);
    },
  });
  preventDefault && ev.preventDefault();
};

export const markAllAsRead = (
  setNumberOfUnread: Dispatch<SetStateAction<number>>,
  userID: number,
  markAllAlertsAsRead: any,
  queryClient: any,
  refetch: any,
  enqueueSnackbar: any,
) => {
  markAllAlertsAsRead.mutate({
    onSuccess: async () => {
      setNumberOfUnread(0);
      await queryClient.invalidateQueries(["getNotifications"], {
        refetchType: "all",
      });
      refetch();
    },
    onError: (saveError: RESTAPIErrorType) => {
      handleRESTErrors(saveError, enqueueSnackbar);
    },
  });
};

export const orderedAlerts = (alerts: Alert[]) => {
  if (alerts) {
    return Object.values(alerts).sort(
      (a: any, b: any) =>
        // @ts-ignore
        DateTime.fromISO(b.created_at) - DateTime.fromISO(a.created_at),
    );
  }
};
